import { render, staticRenderFns } from "./InsuranceQuickVerify.vue?vue&type=template&id=5bfb2c12&scoped=true"
import script from "./InsuranceQuickVerify.vue?vue&type=script&lang=js"
export * from "./InsuranceQuickVerify.vue?vue&type=script&lang=js"
import style0 from "./InsuranceQuickVerify.vue?vue&type=style&index=0&id=5bfb2c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb2c12",
  null
  
)

export default component.exports